export default __webpack_public_path__ + "static/media/1.b438a780.mp3";